import { render, staticRenderFns } from "./Cadastro.vue?vue&type=template&id=0cb5f4a0&scoped=true&lang=pug"
import script from "./Cadastro.vue?vue&type=script&lang=js"
export * from "./Cadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb5f4a0",
  null
  
)

export default component.exports